export default "__VITE_ASSET__e4be31df__"